var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-inner"},[_c('a',{attrs:{"href":_vm.message.payload.url,"target":"_blank"}},[_c('img',{staticClass:"bg_img",attrs:{"src":_vm.message.payload.url}})]),_c('p',{staticClass:"text_xs mt-2"},[_vm._v(_vm._s(_vm.messageTime(_vm.message.created_at)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }